import React from 'react';
import './App.css';

const TermsOfService = () => {
  return (
    <div className="App">
      <div>
        <h1>PteroBuddy Terms of Service</h1>
        <p><strong>Effective Date: [ 6 - Dec - 2024 ]</strong></p>

        <p>
          Welcome to the PteroBuddy Terms of Service. By adding or using PteroBuddy, our Discord bot, in your server, you agree to abide by these terms. If you do not agree with these terms, you must not use the bot.
        </p>

        <h2>1. Use of the Bot</h2>
        <p>PteroBuddy is a bot designed to integrate with the Pterodactyl server management panel. By using the bot, you agree to the following:</p>
        <ul>
          <li><strong>Authorized Use:</strong> Use the bot only within Discord servers where you have permission to add bots.</li>
          <li><strong>Proper Configuration:</strong> Ensure that the bot is configured correctly to prevent unintended actions such as server deletions, user removals, or unauthorized changes.</li>
          <li><strong>Compliance:</strong> Adhere to Discord's Terms of Service and Community Guidelines while using the bot.</li>
        </ul>

        <h2>2. Bot Functionality</h2>
        <p>PteroBuddy provides the following key features:</p>
        <ul>
          <li><strong>Pterodactyl Integration:</strong> Allows server management, including user and server creation, deletion, and configuration.</li>
          <li><strong>Server Logs:</strong> Logs actions performed by users to monitor and track potential security issues.</li>
          <li><strong>Bot Access Control:</strong> Manages bot access to specific servers.</li>
          <li><strong>Customizable Settings:</strong> Allows server admins to adjust bot settings to fit their needs.</li>
        </ul>
        <p>While we strive for accuracy, we do not guarantee that the bot will always prevent or handle all possible issues in Pterodactyl server management.</p>

        <h2>3. User Responsibilities</h2>
        <p>As a user of PteroBuddy, you are responsible for:</p>
        <ul>
          <li><strong>Proper Configuration:</strong> Ensure the bot is correctly set up and that all sensitive commands are used responsibly.</li>
          <li><strong>Monitoring Logs:</strong> Regularly check logs for security issues and take appropriate action when needed.</li>
          <li><strong>Compliance with Policies:</strong> Ensure that your use of the bot complies with Discord’s and Pterodactyl’s Terms of Service and Community Guidelines.</li>
        </ul>

        <h2>4. Limitations of Liability</h2>
        <p>To the fullest extent permitted by law, PteroBuddy and its developers are not liable for:</p>
        <ul>
          <li>Any damages, data loss, or other issues arising from the use or inability to use PteroBuddy.</li>
          <li>Actions taken by the bot based on its configuration.</li>
          <li>Failures in detecting or preventing malicious activity.</li>
          <li>Unintended consequences due to the bot’s actions.</li>
        </ul>

        <h2>5. Changes to the Service</h2>
        <p>We reserve the right to modify, suspend, or discontinue any part of PteroBuddy at any time. We will attempt to provide notice of significant changes through Discord or bot notifications.</p>

        <h2>6. Termination</h2>
        <p>We may suspend or terminate your access to PteroBuddy immediately, without notice or liability, for any reason, including if you breach these Terms of Service.</p>

        <h2>7. Changes to the Terms</h2>
        <p>We may update these Terms of Service from time to time. Any significant changes will be communicated to users via Discord notifications or updates in the bot. Continued use of PteroBuddy after changes indicates acceptance of the updated terms.</p>

        <h2>8. Contact Us</h2>
        <p>If you have any questions about these Terms of Service, please contact us at:</p>
        <ul>
          <li>Email: <a href="mailto:support@pterobuddy.io">support@pterobuddy.io</a></li>
          <li>Discord: <a href="https://discord.gg/yourserver">Join our support server</a></li>
        </ul>

        <footer>
          <p>&copy; 2024 PteroBuddy. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default TermsOfService;
